import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { zahlungenApi } from '../api';

const TYP_ICONS = {
  'Sparvertrag': '💰', 'Kredit': '🏦', 'Versicherung': '🛡️', 'Abo': '📱'
};
const TYP_FARBEN = {
  'Sparvertrag': '#10b981', 'Kredit': '#ef4444', 'Versicherung': '#3b82f6', 'Abo': '#8b5cf6'
};

function monatlich(z) {
  const b = z.betrag;
  switch(z.intervall) {
    case 'monatlich': return b;
    case 'vierteljaehrlich': return b / 3;
    case 'halbjaehrlich': return b / 6;
    case 'jaehrlich': return b / 12;
    default: return b;
  }
}

export default function ZahlungenPage() {
  const navigate = useNavigate();
  const [zahlungen, setZahlungen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterTyp, setFilterTyp] = useState('');
  const [filterRichtung, setFilterRichtung] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => { laden(); }, [filterTyp, filterRichtung]);

  async function laden() {
    setLoading(true);
    try {
      const params = { status: 'aktiv' };
      if (filterTyp) params.typ = filterTyp;
      const res = await zahlungenApi.list(params);
      setZahlungen(res.data);
    } catch(e) { console.error(e); }
    setLoading(false);
  }

  async function loeschen(id) {
    if (!window.confirm('Zahlung wirklich löschen?')) return;
    await zahlungenApi.delete(id);
    laden();
  }

  const gefiltert = zahlungen.filter(z => {
    if (filterRichtung && z.richtung !== filterRichtung) return false;
    if (search && !z.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const monatAusgaben = gefiltert.filter(z => z.richtung === 'ausgabe').reduce((s,z) => s + monatlich(z), 0);
  const monatEinzahl = gefiltert.filter(z => z.richtung === 'einzahlung').reduce((s,z) => s + monatlich(z), 0);
  const saldo = monatEinzahl - monatAusgaben;

  const intervallLabel = { monatlich: 'mtl.', vierteljaehrlich: 'vj.', halbjaehrlich: 'hj.', jaehrlich: 'jährl.', einmalig: 'einm.' };

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h1 style={{ margin: 0, fontSize: '28px' }}>💳 Zahlungen</h1>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button onClick={() => navigate('/zahlungen/auswertung')} style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>📊 Auswertung</button>
          <button onClick={() => navigate('/zahlungen/neu')} style={{ padding: '10px 20px', background: '#818cf8', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>+ Neu</button>
        </div>
      </div>

      {/* KPI Karten */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {[
          { label: 'Monatl. Ausgaben', wert: monatAusgaben, farbe: '#ef4444', icon: '📤' },
          { label: 'Monatl. Einzahlungen', wert: monatEinzahl, farbe: '#10b981', icon: '📥' },
          { label: 'Monatl. Saldo', wert: saldo, farbe: saldo >= 0 ? '#10b981' : '#ef4444', icon: '⚖️' },
        ].map((k, i) => (
          <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderLeft: `4px solid ${k.farbe}` }}>
            <div style={{ fontSize: '20px', marginBottom: '6px' }}>{k.icon}</div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: k.farbe }}>{k.wert.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</div>
            <div style={{ color: '#64748b', fontSize: '12px', marginTop: '4px' }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Filter */}
      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <input placeholder="🔍 Suche..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', flex: 1, minWidth: '150px' }} />
        <select value={filterTyp} onChange={e => setFilterTyp(e.target.value)}
          style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
          <option value="">Alle Typen</option>
          {['Sparvertrag','Kredit','Versicherung','Abo'].map(t => <option key={t} value={t}>{TYP_ICONS[t]} {t}</option>)}
        </select>
        <select value={filterRichtung} onChange={e => setFilterRichtung(e.target.value)}
          style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
          <option value="">Alle Richtungen</option>
          <option value="ausgabe">📤 Ausgaben</option>
          <option value="einzahlung">📥 Einzahlungen</option>
        </select>
      </div>

      {/* Liste */}
      {loading ? <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>Lade...</div>
        : gefiltert.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>💳</div>
            <div>Keine Zahlungen gefunden</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {gefiltert.map(z => (
              <div key={z.id} style={{ background: 'white', borderRadius: '12px', padding: '16px 20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', gap: '16px', borderLeft: `4px solid ${TYP_FARBEN[z.typ] || '#6366f1'}` }}>
                <div style={{ fontSize: '28px' }}>{TYP_ICONS[z.typ] || '💳'}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '4px' }}>{z.name}</div>
                  <div style={{ color: '#64748b', fontSize: '13px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <span style={{ background: TYP_FARBEN[z.typ] + '20', color: TYP_FARBEN[z.typ], padding: '2px 8px', borderRadius: '99px', fontWeight: '600' }}>{z.typ}</span>
                    {z.untertyp && <span>📌 {z.untertyp}</span>}
                    {z.anbieter && <span>🏢 {z.anbieter}</span>}
                    {z.zinssatz && <span>📈 {z.zinssatz}% p.a.</span>}
                    {z.ende && <span>⏳ bis {new Date(z.ende).toLocaleDateString('de-DE')}</span>}
                    {z.aktueller_wert && <span style={{ color: '#10b981', fontWeight: '600' }}>💼 {z.aktueller_wert.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</span>}
                  </div>
                </div>
                <div style={{ textAlign: 'right', minWidth: '120px' }}>
                  <div style={{ fontWeight: '700', fontSize: '18px', color: z.richtung === 'einzahlung' ? '#10b981' : '#ef4444' }}>
                    {z.richtung === 'einzahlung' ? '+' : '-'}{z.betrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
                  </div>
                  <div style={{ color: '#94a3b8', fontSize: '12px' }}>{intervallLabel[z.intervall] || z.intervall}</div>
                  <div style={{ color: '#6366f1', fontSize: '12px', fontWeight: '600' }}>{monatlich(z).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}/mtl.</div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => navigate('/zahlungen/' + z.id + '/bearbeiten')}
                    style={{ padding: '6px 14px', background: '#f1f5f9', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>✏️</button>
                  <button onClick={() => loeschen(z.id)}
                    style={{ padding: '6px 14px', background: '#fee2e2', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
